import { useEffect, useState } from "react";
import CookieSettings from "./CookieSettings";

function CookieBanner() {

  const [show, setShow] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {

    const consent = localStorage.getItem("cookieConsent");

    if (!consent) {
      setShow(true);
    }

  }, []);

  const acceptAll = () => {

    const consent = {
      necessary: true,
      preferences: true,
      analytics: true
    };

    localStorage.setItem("cookieConsent", JSON.stringify(consent));

    setShow(false);
  };

  const rejectAll = () => {

    const consent = {
      necessary: true,
      preferences: false,
      analytics: false
    };

    localStorage.setItem("cookieConsent", JSON.stringify(consent));

    setShow(false);
  };

  if (!show) return null;

  return (

    <>
      <div style={{
        position: "fixed",
        bottom: "0",
        width: "100%",
        background: "#1f2937",
        color: "white",
        padding: "15px",
        textAlign: "center",
        zIndex: "9999"
      }}>

        <p>We use cookies to improve your experience.</p>

        <button onClick={acceptAll}>Accept All</button>

        <button onClick={rejectAll} style={{marginLeft:"10px"}}>
          Reject All
        </button>

        <button
          onClick={() => setShowSettings(true)}
          style={{marginLeft:"10px"}}
        >
          Customize
        </button>

      </div>

      {showSettings && (
        <CookieSettings close={() => setShowSettings(false)} />
      )}

    </>
  );
}

export default CookieBanner;